export default "__VITE_ASSET__DbgJUSJx__"